module.exports = __webpack_public_path__ + "media/images/shared/delivery/sdek-fdb3c75d56775fec99b9653247011b42.jpg";